/**
 * Re-export the Cascade admin portal config so the rest of the app has one
 * place to import branding / nav / module metadata from.
 */
import portalApp from '@command-center/admin-cascade';
import type { PortalAppConfig } from '@command-center/core-platform';

export const adminConfig: PortalAppConfig = portalApp.config;
export const adminApp = portalApp;
